export const addBaseScenarioCollectionFromAPI = ( baseScenarioCollection ) => {
    console.log(baseScenarioCollection);
    return({
        type: "LOAD_SCENARIO_COLLECTION_FROM_API",
        baseScenarioCollectionData: baseScenarioCollection.data,
        pages: baseScenarioCollection.pages,
        currentPage: baseScenarioCollection.current_page
    })
}

export const updateBaseScenarioInfo = (scenarioName, isChecked) => {
    return({
        type : "UPDATE_BASE_SCENARIO_INFO",
        scenarioName,
        isChecked
    })
}


export const updateInnerBaseScenarioInfo = (scenarioName, isChecked) => {
    return( {
        type : "UPDATE_INNER_BASE_SCENARIO_INFO",
        scenarioName,
        isChecked
    })
}
